import db from "../../database";
import moment from "moment";
import store from "../index";

export const log = (data) => {
  let type = data.type;
  let log = data.log;
  let status = data.status;
  let logsData = {
    date: moment().format("DD-MM-YYYY hh:mm:ss A"),
    status: status.toUpperCase(),
    source: type.toUpperCase(),
    response: data.hasOwnProperty("response") ? data.response : "",
    terminal_details: {
      terminal_id: parseInt(store.state.system.settings.terminal_id),
      v_id: parseInt(store.state.sessions.user.v_id),
      store_id: parseInt(store.state.sessions.user.store_id),
      vu_id: parseInt(store.state.sessions.user.vu_id),
    },
  };
  if (type == "load" || type == "reload") {
    logsData.description = loaded(type);
  } else if (type == "item_master") {
    logsData.description = itemMaster(log, status);
  } else if (type == "process_to_payment" && status == "success") {
    logsData.description = createOrder(log, status);
  } else if (type == "save_payment_method") {
    logsData.description = savePaymentMethod(log);
  } else if (type == "save_payment" && status == "success") {
    logsData.description = savePayment(log);
  } else if (status == "error" && type != "item_master") {
    logsData.description = logWithOrWithoutBarcode(type, log);
  } else if (status == "success" && type == "remove_product") {
    logsData.description = removeProduct(log);
  } else if (status == "success" && type == "remove_manual_discount") {
    logsData.description = "Manual discount removed successfully!";
  } else if (status == "success" && type == "set_manual_discount") {
    logsData.description =
      "Manual Discount of basis: " +
      log.basis +
      " and factor: " +
      log.factor +
      " applied.";
  } else if (status == "success" && type == "open_session") {
    logsData.description =
      "Session opened successfully {session_id: " + log.sessionId + " }.";
  } else if (status == "success" && type == "close_session") {
    logsData.description = "Session closed successfully.";
  } else if (status == "success" && type == "state_change_online") {
    logsData.description = "Switched to Online";
  } else if (status == "success" && type == "state_change_offline") {
    logsData.description = "Switched to Offline";
  }
  db.logs.put(logsData);
};

function loaded(type) {
  if (type == "load") return "Loaded for the first time!";
  else if (type == "reload") return "Page reloaded!";
}

function itemMaster(log, status) {
  if (status == "success")
    return (
      "Batch_" +
      log.batch +
      " from: " +
      log.from +
      " to: " +
      log.to +
      " synced."
    );
  else if (status == "error")
    return (
      "Batch_" +
      log.batch +
      " from: " +
      log.from +
      " to: " +
      log.to +
      " not synced."
    );
}

function createOrder(log, status) {
  if (status == "success")
    return "Order: " + log.orderId + " created successfully!";
  else if (status == "error") return "Error in creating order: " + log.orderId;
}

function savePayment(log) {
  return (
    "Invoice " + log.invoiceId + " generated for Order " + log.orderId + "."
  );
}

function savePaymentMethod(log) {
  return (
    "Payment of ₹" + log.amount + " captured for order id: " + log.orderId + "."
  );
}

function logWithOrWithoutBarcode(type, log) {
  if (
    type == "product_qty_update" ||
    type == "product_details" ||
    type == "remove_product"
  ) {
    return log.name + ": " + log.message + " for " + log.barcode + ".";
  } else if (
    type == "get_profile" ||
    type == "login_for_customer" ||
    type == "un_tag_customer" ||
    type == "cart_details" ||
    type == "process_to_payment" ||
    type == "save_payment" ||
    type == "get_carry_bags" ||
    type == "save_carry_bags" ||
    type == "set_manual_discount" ||
    type == "remove_manual_discount" ||
    type == "invoice_history" ||
    type == "invoice_search" ||
    type == "order_details" ||
    type == "order_recall" ||
    type == "get_print" ||
    type == "open_session" ||
    type == "close_session" ||
    type == "settings"
  )
    return log.name + ": " + log.message + ".";
  else if (type == "register_user" || type == "user_login")
    return log.name + ": " + log.message + " for mobile: " + log.mob;
}

function removeProduct(log) {
  if (log.all == "1") return "Cart cleared successfully!";
  else return "Barcode: " + log.barcode + " removed from cart.";
}
